import React from 'react';
const stats = [{
  value: '20+',
  label: 'Países hispanohablantes donde ya se usa el sistema'
}, {
  value: '6 + 5',
  label: 'Tomos operativos y herramientas de campo'
}, {
  value: '4.9/5',
  label: 'Valoración promedio'
}, {
  value: 'De punta a punta',
  label: 'Del primer «Hola, ¿precio para boda?» a la recomendación final'
}];
export function SocialProofBar() {
  return <section aria-label="Prueba social" className="w-full bg-ink text-ivory" data-id="element-219" data-mp="32iuxda5dq60n">
      <div className="mx-auto grid max-w-6xl grid-cols-2 gap-y-8 px-5 py-10 sm:grid-cols-4 sm:divide-x sm:divide-gold/25" data-id="element-220" data-mp="32gqpkh4d0mv3">
        {stats.map(stat => <div key={stat.label} className="px-4 text-center" data-id="element-221" data-mp="2th3ndt3t3d0z">
            <div className="font-serif text-2xl sm:text-3xl text-gold" data-id="element-222" data-mp="2ojv5ltmklb09">{stat.value}</div>
            <div className="mt-2 text-[11px] uppercase tracking-[0.16em] text-ivory/60" data-id="element-223" data-mp="1i2zxay0ca917">
              {stat.label}
            </div>
          </div>)}
      </div>
    </section>;
}